<template>
  <div class="overflow-hidden h-100 w-100 font_Montserrat">
    <template v-if="hasRequiredQuestions">
      <div class="col-sm-12 col-md-12 col-lg-12">
        <div
          class="mb-2 font_size_1125rem font-weight-bold v3_color_teal my-0 border_bottom_1 border_bottom_light_teal"
        >
          {{ jobProfileTitle }}
        </div>
        <div class="mb-3">
          <job-profile-preference-answer
            v-for="jq in jobQuestions"
            :key="jq.id"
            :job-question="jq"
            :is-selected="jq.id === editedQuestionId"
          >
            <div slot="right-section">
              <span class="select-icon-wrapper">
                <i
                  aria-hidden="true"
                  class="mdi mdi-pencil clickable"
                  @click="$emit('select-question', jq.id)"
                />
              </span>
            </div>
          </job-profile-preference-answer>
        </div>
      </div>
    </template>

    <template v-if="hasOptionalQuestions">
      <div class="col-sm-12 col-md-6 col-lg-12">
        <div
          class="mb-2 font_size_1125rem font-weight-bold v3_color_teal my-0 border_bottom_1 border_bottom_light_teal"
        >
          Additional Terms
      </div>
        <job-profile-preference-answer
          v-for="jq in optionalQuestions"
          :key="jq.id"
          :job-question="jq"
          :is-selected="jq.id === editedQuestionId"
        >
          <div slot="right-section">
            <span class="select-icon-wrapper">
              <i
                aria-hidden="true"
                class="mdi mdi-pencil clickable"
                @click="$emit('select-question', jq.id)"
              />
            </span>
          </div>
        </job-profile-preference-answer>
      </div>
    </template>
  </div>
</template>

<script>
import JobProfilePreferenceAnswer from '@/components/exchange/preference-list/JobProfilePreferenceAnswer';

export default {
  name: 'JobProfilePreferenceAnswerList',
  components: { JobProfilePreferenceAnswer },
  props: {
    jobProfileTitle: {
      type: String,
      default: null,
    },
    jobQuestions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    selectedOptionalQuestions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    optionalQuestions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    editedQuestionId: Number,
  },
  computed: {
    hasOptionalQuestions: function () {
      return !!this.optionalQuestions.length;
    },
    hasRequiredQuestions: function () {
      return !!this.jobQuestions.length;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../sass/variables_mixins';
i.mdi {
  color: $phairify_primary_color_icon;
  font-size: $phairify_icon-size_large;
  line-height: $phairify_icon-size_large;
  &.size-medium {
    font-size: $phairify_icon-size_medium;
    line-height: $phairify_icon-size_medium;
  }
  &:hover {
    cursor: pointer;
  }
}

.select-icon-wrapper {
  .mdi.mdi-pencil {
    color: $phairify_v2_color_primary_teal;
    font-size: 24px;
  }
}
</style>
